module.exports = __webpack_public_path__ + "static/media/cash-on-delivery.b5209598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/cash-on-delivery.png
// module id = 220
// module chunks = 0